import { RouteObject } from "react-router-dom";
import Create from "./components/create/create";
import Landing from "./components/landing/landing";
import FailureDetail from "./components/details/details";


export interface axFieldAlerts extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: axFieldAlerts[];
}
export const axFieldAlerts: axFieldAlerts[] = [
  {
    path: "/ax/field-alerts/failure",
    element: <Landing />,
  },
  {
    path: "/ax/field-alerts/failure/report/:action",
    element: <Create />,
  },
    {
    path: "/ax/field-alerts/failure/report/:action/:id",
    element: <Create />,
  },

  {
    path: "/ax/field-alerts/failure/:id", // Add this route
    element: <FailureDetail />,
  },
];
